import { Component, OnInit, Input} from '@angular/core';

@Component({
    selector: 'app-return-fillup-instructions-en-v2',
    templateUrl: './return-fillup-instructions-en-v2.component.html',
    styleUrls: ['./return-fillup-instructions-en-v2.component.css'],
    standalone: false
})
export class ReturnFillupInstructionsEnV2Component implements OnInit {

  @Input() printActive: boolean

  constructor() { }

  ngOnInit(): void {
  }

}
